'use client';

import { Shield, Wrench, Battery } from 'lucide-react';

export default function Advantages() {
  const advantages = [
    {
      id: 1,
      title: 'Garantie 12 mois',
      description: 'Tous nos téléphones sont garantis 12 mois, 100% de tranquillité d\'esprit.',
      icon: Shield,
    },
    {
      id: 2,
      title: 'Téléphones neufs',
      description: 'Inspection complète et remise à neuf par nos experts techniques.',
      icon: Wrench,
    },
    {
      id: 3,
      title: 'Batteries neuves',
      description: 'Batteries neuves installées pour une autonomie optimale.',
      icon: Battery,
    },
  ];

  return (
    <section id="advantages" className="py-12 sm:py-16 lg:py-20 bg-linear-to-br from-white via-blue-50/30 to-white relative overflow-hidden">

      <div className="absolute top-0 right-0 w-96 h-96 bg-[#23994F]/5 rounded-full blur-3xl -mr-32 -mt-32 pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-72 h-72 bg-blue-400/5 rounded-full blur-3xl -ml-32 -mb-32 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <div className="text-center mb-8 sm:mb-12 lg:mb-16 fade-in">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Pourquoi nous choisir ?
          </h2>
          <p className="text-base sm:text-lg text-gray-600">
            Découvrez nos avantages clés qui font la différence
          </p>
        </div>


        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {advantages.map((advantage, idx) => {
            const Icon = advantage.icon;

            return (
              <div
                key={advantage.id}
                className="stagger-item bg-white rounded-xl sm:rounded-2xl shadow-md hover:shadow-2xl p-6 sm:p-8 transition-all duration-300 border-2 border-gray-100 hover:border-[#23994F] transform hover:scale-102 hover:-translate-y-1 group bg-linear-to-br from-white to-gray-50/50"
                style={{ animationDelay: `${idx * 0.15}s` }}
              >

                <div className="w-14 h-14 sm:w-16 sm:h-16 bg-linear-to-br from-[#23994F]/15 to-blue-400/15 rounded-full flex items-center justify-center mb-4 sm:mb-6 group-hover:from-[#23994F]/25 group-hover:to-blue-400/25 transition-all duration-300 transform group-hover:scale-105">
                  <Icon size={28} className="sm:w-8 sm:h-8 text-[#23994F] transition-transform duration-300 group-hover:rotate-12 group-hover:scale-105" />
                </div>


                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">
                  {advantage.title}
                </h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                  {advantage.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
